import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { formatShortDate } from "common/helpers/utils";
import type { PricingPeriodUnit } from "common/types";

import Banner from "../../Banner";

interface LicenseBannersProps {
  licenseCount: number;
  selectedPeriodUnit: PricingPeriodUnit;
}

export default function LicenseBanners({
  licenseCount,
  selectedPeriodUnit,
}: LicenseBannersProps) {
  const {
    subscription,
    license_count: workspaceLicenseCount,
    lifetime_license_count: lifetimeLicenseCount,
  } = useSelectedWorkspaceContext();

  const isLifetimeDeal = lifetimeLicenseCount > 0;
  const isDowngrade = licenseCount < workspaceLicenseCount;

  const isMonthlySubscription =
    subscription && subscription.item_price.period_unit === "month";

  const isUpgradeToYearly =
    isMonthlySubscription && selectedPeriodUnit === "year";

  if (isUpgradeToYearly) {
    return (
      <Banner
        variant="info"
        textNode="Switching your subscription to yearly billing is effective for all current and future seat purchases"
      />
    );
  }

  if (isDowngrade) {
    return (
      <Banner
        textNode="This is a scheduled change. Your subscription will not change until your next billing date"
        variant="warning"
      />
    );
  }

  if (!isLifetimeDeal && subscription && subscription.status === "in_trial") {
    const nextBillingDate = formatShortDate(subscription.next_billing * 1000);

    return (
      <Banner
        textNode={`You will not be charged until your  trial expires. Your subscription will automatically upgrade to a paid plan on ${nextBillingDate}`}
        variant="gradient"
      />
    );
  }

  return <span className="h-px w-full bg-black-200" />;
}
